// extracted by mini-css-extract-plugin
module.exports = {"row":"style_row__3HpJF","cell":"style_cell__A_ag4","alive":"style_alive__2bccc","grid":"style_grid__1xLxb","gridContainer":"style_gridContainer__2T5E1"};